import axios from 'axios';

export default axios.create({
     baseURL: process.env.REACT_APP_BASE_API_URL+'/api',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization':'Bearer '+localStorage.getItem("xller_token")??""
    }
});